import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';

const ParamsInputIO = t.array(
    t.interface({
        legs: t.array(
            t.interface({
                eventId: t.union([t.number, t.undefined]),
                marketId: t.union([t.number, t.undefined]),
                selectionId: t.union([t.number, t.undefined]),
                type: t.union([t.string, t.undefined]),
            })
        ),
    })
);

const isParamsInput = createGuard(ParamsInputIO);

interface ResultItemType {
    selectionId: string;
    uuid: string;
}

interface GetItemType {
    id: string; //selectionId
    uuid: string;
}

const getItem = async (eventId: number, marketId: number, selectionId: number): Promise<GetItemType> => {
    const selectionId2 = $appState.sdkStaff.models.id
        .getEventId(eventId)
        .getMarketId(marketId)
        .getSelectionId(selectionId);

    const selectionModel = await selectionId2.getModelAsync();

    if (selectionModel.uuid === null) {
        throw new Error(`getEventsWithUuid: Missing uuid for selectionId=${selectionModel.id2.key}`);
    }

    return {
        id: selectionModel.id2.rawId,
        uuid: selectionModel.uuid,
    };
};

export const getEventsWithUuid = async (bets: unknown): Promise<Record<string, ResultItemType>> => {
    if (!isParamsInput(bets)) {
        console.error('getEventsWithUuid - incorrect parameters', bets);
        return {};
    }

    const tempEventMarketSelectionId: Array<{ eventId?: number; marketId?: number; selectionId?: number }> = [];

    for (const bet of bets) {
        for (const leg of bet.legs) {
            if (leg.type === 'betBuilder') {
                continue;
            }
            const isElemExist = tempEventMarketSelectionId.some((elem) => elem.selectionId === leg.selectionId);
            if (isElemExist === false) {
                tempEventMarketSelectionId.push({
                    eventId: leg.eventId,
                    marketId: leg.marketId,
                    selectionId: leg.selectionId,
                });
            }
        }
    }

    const promises = [];
    const responses: Record<string, ResultItemType> = {};

    for (const eventMarketId of tempEventMarketSelectionId) {
        if (
            eventMarketId.eventId !== undefined &&
            eventMarketId.marketId !== undefined &&
            eventMarketId.selectionId !== undefined
        ) {
            promises.push(getItem(eventMarketId.eventId, eventMarketId.marketId, eventMarketId.selectionId));
            // promises.push(api.get(`/events/${eventMarketId.eventId}/markets/${eventMarketId.marketId}/selections/${eventMarketId.selectionId}`));
        }
    }

    const allPromises = await Promise.all(promises);

    for (const resp of allPromises) {
        responses[resp.id] = {
            selectionId: resp.id,
            uuid: resp.uuid,
        };
    }
    return responses;
};
